// @flow strict

import * as React from 'react';
import classnames from '@ta/common.classnames';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Icon.css';

// eslint-disable-next-line css-modules/no-unused-class
import content from './content.css';
import type { IconName } from './types';

/** Component props for an Icon */
export type Props = {|
  /** Child elements */
  children?: React.Node,

  /** Color */
  color?:
    | 'taGreen'
    | 'accessibleGreen'
    | 'taNotificationRed'
    | 'grayDottedSeparator'
    | 'socialGray'
    | 'gray1'
    | 'black'
    | 'inherit',

  /** Font size */
  fontSize?: number,

  /** The icon name */
  name: IconName,
|};

/** The icon names that should not mirror on a rtl site */
const SKIP_MIRROR_ICON_NAMES = new Set([
  'checkbox-checked',
  'checkmark',
  'checkmark-boxed',
  'checkmark-circle-fill',
  'facebook',
  'instagram',
  'pinterest',
  'question-circle',
  'question-circle-fill',
  'twitter',
  'youtube',
]);

const Icon = ({ color, fontSize, name, children }: Props) => (
  <span
    className={classnames(
      content[name],
      styles.icon,
      {
        [styles[color]]: styles[color],
      },
      SKIP_MIRROR_ICON_NAMES.has(name) && styles.disableRtlMirror,
    )}
    style={{ fontSize }}
  >
    {children}
  </span>
);

/**
 * Render a TripAdvisor icon that works in any size and color. See below examples for the variety of
 * icon names that can be used.
 */
export default Icon;
